import type { SlateContent } from '../types';
import { getEmptyRequiredFields } from '../../RichTextEditor/utils/requiredFields';
import { getEmptyPlaceholderFields } from '../../RichTextEditor/plugins/placeholder/utils';

/**
 * Pure submission-validation helpers. Both encode the same business rule that was previously inline
 * in Fields.Context: prelim submissions intentionally skip empty required-field and empty-placeholder
 * enforcement. They perform no side effects and read no external state.
 */

export const findEnforcedEmptyRequiredFields = ({
  content,
  isPrelim,
}: {
  content: SlateContent;
  isPrelim: boolean;
}): ReturnType<typeof getEmptyRequiredFields> => (isPrelim ? [] : getEmptyRequiredFields(content));

export const findBlockingPlaceholders = ({
  content,
  isPrelim,
}: {
  content: SlateContent;
  isPrelim: boolean;
}): ReturnType<typeof getEmptyPlaceholderFields> =>
  isPrelim ? [] : getEmptyPlaceholderFields(content);
